<template>
  <NuxtRouteAnnouncer />
  <UApp>
    <NuxtLayout>
      <MainLayout v-if="loadMainLayout">
          <NuxtPage v-if="loadMainLayout" />
      </MainLayout>
      <NuxtPage v-else />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
import MainLayout from "~/layouts/MainLayout.vue";

const i18nHead = useLocaleHead()
const route = useRoute()

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead?.value?.htmlAttrs?.lang || 'en'
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])],
  script: [
    {
      src: 'https://insights.wizzl.app/js/script.js',
      defer: true,
      'data-domain': 'wizzl.app'
    }
  ]
}))

const loadMainLayout = computed(() => {
  const skip = ['/auth', '/privacy', '/terms']
  for(let i = 0; i < skip.length; i++) {
    if(route.path == skip[i] || route.path.startsWith(skip[i] + '/')) return false
  }
  return true
})

useSeoMeta({
  title: 'Wizzl - Support, Create, Grow!',
  description: 'Wizzl is a platform where creators can share exclusive content, engage with their community, and grow their presence with subscription-based access.',
  ogSiteName: 'Wizzl',
  ogTitle: 'Wizzl - Support, Create, Grow!',
  ogDescription: 'Wizzl is a platform where creators can share exclusive content, engage with their community, and grow their presence with subscription-based access.',
  ogImage: 'https://wizzl.app/static/thumbnail.png',
  ogUrl: 'https://wizzl.app',
  twitterCard: 'summary_large_image',
  twitterTitle: 'Wizzl - Support, Create, Grow!',
  twitterDescription: 'Wizzl is a platform where creators can share exclusive content, engage with their community, and grow their presence with subscription-based access.',
  twitterImage: 'https://wizzl.app/static/thumbnail.png',
  colorScheme: 'light dark',
  themeColor: '#7c86ff',
});

const { data: authState } = await useFetch(`/api/state`);
useUserStore().user = authState.value || undefined
</script>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.2s ease;
}

.page-enter-from, .page-leave-to {
  opacity: 0;
}
</style>